/**
 * Copyright 2000, 2015 Southwest Gas Corporation.  All rights reserved.
 * This JavaFX application is a GUI interface for the
 * Southwest Gas gas meter application.  The application displays a
 * series of 4 dials that simulate the behavior of a standard gas meter.
 * The digit "read" is displayed below each dial.
 *
 * The meter can be set in a "run" mode by typing "Enter" or "Return".
 *
 * Clicking on the dial will set the read for that dial, in accordance
 * with the position of the neighboring dials.  The digit can be set
 * by clicking on it with a mouse and typing the number on the key board.
 *
 * Traversal between dials is done using the "Tab" key.
 *
 * The hands can also be moved by dragging them with a mouse.
 *
 * Author: Joseph W. Haller, Ph.D.
 *         Programmer/Analyst
 *         Southwest Gas Corporation
 *         March 23, 2000
 
 * 2015-03-02 -- JWH6
 * 
 * Southwest Gas Corporation Gas Meter Display.  This version migrates the Gas
 * Meter Display from a Java Applet (written in 2000) to JavaFX (now in 2015).
 * 
 * 2015-10-20 -- JWH6
 * Conversion from Java/JavaFX to HTML5/JavaScript.  Click on dial to select dial.
 * Type numerical digit to set the diail.  Press "Enter" or "Return" to start/stop
 * the gas meter display.
 *
 * 2016-11-03 -- TAA1
 * Modified image path to work with source in WebCenter Sites
 * Updated code to work with strict compilation of JavaScript
 *
 * @author jwh6
 */

 angular.module('app.controllers.gasmeter', []).controller('GasMeterCtrl',
  ['$scope','$log', function ($scope, $log) {
 
  var echoOutput = false;

  // Reference to the canvas object in the embedding page.
  var canvas = document.getElementById('gasmeter-app');

  // 2D "Graphics Context" used to draw features to canvas.
  var context = canvas.getContext('2d'); 

  //translate(0, canvas.height);
  //scale(1, -1);

  // DEFINE COLORS
  var WHITE = '#ffffff';
  var BLACK = '#000000';
  var RED = '#ff0000';

  var radius = 20;

  // ANIMATION AND MOUSE STATE FLAGS
  var updateAnimation = false;

  // DEFINE IMAGE VARIABLES
  var prefix = WEB_PREFIX || '';
  var image_path = prefix + "images/gasmeter/";
  var dial_face_ccw = new Image();
  var dial_face_cw = new Image();
  var arrow_ccw = new Image();
  var arrow_cw = new Image();
  var digit_images = Array(10);
  for (j = 0; j < digit_images.length; j++) {
      digit_images[j] = new Image();
  }
  var copyrightImage = new Image();

  var dialBuffer_x = 5;
  var dialBuffer_y = 5;

  // MAIN OBJECT TO BE ANIMATED
  // THIS IS THE GAS METER APARATUS
  var gearBox = new GearBox();

  // INITIALIZE ANIMATION THREAD
  window.onload = function () {
      context.imageSmoothingEnabled = false;
      initImages();
      setInterval(onEachStep, 1000 / 40); // 40 fps
      initEventHandlers();
      
      //alert(prefix);
      //alert(image_path);
      //alert(dial_face_ccw.src);
      
  };


  // Initialize the dial face images and copyright image.
  function initImages() {
      // Specify each image resource.
      dial_face_ccw.src = image_path + "dial_face_ccw.gif";
      dial_face_cw.src = image_path + "dial_face_cw.gif";
      arrow_ccw.src = image_path + "arrow_ccw.gif";
      arrow_cw.src = image_path + "arrow_cw.gif";

      // Clear canvas after each image is loaded.
      dial_face_ccw.onload = function () {
          clearCanvas();
      };
      dial_face_cw.onload = function () {
          clearCanvas();
      };
      arrow_ccw.onload = function () {
          clearCanvas();
      };
      arrow_cw.onload = function () {
          clearCanvas();
      };

      for (j = 0; j < digit_images.length; j++) {
          digit_images[j].src = image_path + "digit_" + j + ".gif";
      }

      /*
      for (j = 0; j < digit_images.length; j++) {
          digit_images[j].onload = function () {
              clearCanvas();
          };
      }
      */

      copyrightImage.src = image_path + "swgcopyright.gif";

      copyrightImage.onload = function () {
          clearCanvas();
      };
  }

  // Update the kinematic variables of the ball, then draw.
  // This function will be called at each time step.
  function onEachStep() {
      gearBox.update(1.0 / 40.0);
      repaint();
  }


  // PAINT THE GAS METER DISPLAY
  function repaint() {
      clearCanvas();
      gearBox.draw();
      drawCopyright();
  }

  // WIPE THE CANVAS CLEAN
  function clearCanvas() {
      context.clearRect(0, 0, canvas.width, canvas.height);
  }

  function drawCopyright() {
    context.drawImage(copyrightImage, 105.0, 135.0);
  }

  function getCursorPosition(event) {
      var rect = canvas.getBoundingClientRect();
      var x = event.clientX - rect.left;
      var y = event.clientY - rect.top;
      return [x, y];
  }

  function onMouseDown(evt) {

      var xy_coords = getCursorPosition(evt);

      // If the animation is running, stop it for any mouse action.
      if (updateAnimation) {
          updateAnimation = false;
      }

      if (gearBox.isDigitSelectedByXY(xy_coords[0], xy_coords[1])) {
          repaint();
      }

      if (echoOutput) {
          console.log("onMouseDown: (" + xy_coords[0] + "," + xy_coords[1] + ")");
      }
  }


  function onMouseMove(evt) {

      var xy_coords = getCursorPosition(evt);
  }

  function onMouseUp(evt) {

      var xy_coords = getCursorPosition(evt);

      if (echoOutput) {
          console.log("onMouseUp: (" + xy_coords[0] + "," + xy_coords[1] + ")");
      }

  }

  function onClick(evt) {

      var xy_coords = getCursorPosition(evt);

      if (echoOutput) {
          console.log("onClick: (" + xy_coords[0] + "," + xy_coords[1] + ")");
      }

  //    if (gearBox.isDialClicked(xy_coords[0], xy_coords[1])) {
  //        if(echoOutput) {
  //            console.log("Dial selected!");
  //        }
  //        repaint();
  //    }

      if (gearBox.isDigitSelectedByXY(xy_coords[0], xy_coords[1])) {
          if (echoOutput) {
              console.log("Digit selected!");
          }
          repaint();
      }
      if (gearBox.isDialClicked(xy_coords[0], xy_coords[1])) {
          if (echoOutput) {
              console.log("isDialClicked selected!");
          }
          repaint();
      }

  }

  function onKeyPress(evt) {

      var TAB = 9;
      var ENTER = 13;
      var _0 = 48;
      var _9 = 57;

      if (echoOutput) {
          console.log("Entered onKeyPress EventHandler");
          console.log("evt.which=" + evt.which);
          console.log("evt.keyCode=" + evt.keyCode);
      }

      // If the ENTER key is pressed, start the animation if it
      // is not running already.
      // Otherwise, stop the animation for any key press.
      if (evt.which === ENTER || evt.keyCode === ENTER) {
          if (updateAnimation) {
              updateAnimation = false;
          } else {
              updateAnimation = true;
          }
      } else {
          if (updateAnimation) {
              updateAnimation = false;
          }
      }

      if (_0 <= evt.which && evt.which <= _9) {
          if (echoOutput) {
              console.log("testing evt.which=" + evt.which);
          }
          if (gearBox.isDigitTyped(evt.which)) {
              repaint();
          }
      }
      if (_0 <= evt.keyCode && evt.keyCode <= _9) {
          if (gearBox.isDigitTyped(evt.keyCode)) {
              repaint();
          }
      }

  }


  /**
   * Function initilizes all of the mouse and keyboard event 
   * handlers.
   * 
   * @returns {undefined}
   */
  function initEventHandlers() {

      // Add the various event listeners to the canvas.
      canvas.addEventListener("mousedown", onMouseDown, false);
      canvas.addEventListener("mousemove", onMouseMove, false);
      canvas.addEventListener("mouseup", onMouseUp, false);
      canvas.addEventListener("click", onClick, false);

      // Add tabindex attribute to canvas tag to allow capture of keyboard events 
      // E.g. <canvas id="canvas" width="410" height="150" tabindex="1" style="border: 1px solid black"></canvas>    
      canvas.addEventListener("keypress", onKeyPress, false);
  }


  /**
   * This class is used to describe
   * the individual dials on the gas meter.  
   * Many details are relegated to this class.
   */
  function DialFace() {

      // "Static Variables"
      DialFace.prototype.centroid = [51, 51];
      DialFace.prototype.radius = 40;

      /*
       * PUBLICALLY AVAILABLE INSTANCE VARIABLES (exposed with "this").
       */

      // Position of dial component
      this.positionOffsets = [0, 0];

      // Boolean Instance Flags
      this.clockwiseLayout = true;

      this.digitSelected = false;
      this.dialSelected = false;

      // Kinematic Variables
      this.dialSpeed = 2.0 * Math.PI / 10.0;
      this.angle = 0.0;
      this.angle_0 = 0.0;

      this.handCoords = [0, 0];
      this.handBase = [0, 0];

      // A set of coordinates that defines a polygon shape 
      // to display the needle.
      this.needle_x = [0.0, 1.0, 1.0];
      this.needle_y = [0.0, 0.0, 1.0];


      // MEMBER FUNCTIONS // 
      // 
      // Returns integer value of the digit currently displayed on the dial.
      this.getDigit = function () {
          return parseInt((10 * ((this.angle % (2 * Math.PI)) / (2 * Math.PI))));
      };

      this.setAngle = function (theta) {
          this.angle = theta;

          //Set the angle in terms of its current phase.   We only need
          //to know the position of the dial to within a fraction of a turn.
          this.angle %= (2 * Math.PI);
          if (this.angle < 0) {
              this.angle += (2 * Math.PI);
          }

          //Compute the pixel coordinates of the end of the needle in local dial coordinates.
          //The x-coordinate must change sign depending on dial layout.
          var x_component = parseInt(Math.round(25 * Math.cos(this.angle - Math.PI / 2)));
          var y_component = parseInt(Math.round(25 * Math.sin(this.angle - Math.PI / 2)));
          this.handCoords[0] = this.handBase[0] + (this.clockwiseLayout ? x_component : -x_component);
          this.handCoords[1] = this.handBase[1] + y_component;

          //Set the coordinates of the needle vertices.
          this.setNeedle(x_component, y_component);
      };

      this.updateAngle = function (deltaTheta) {
          this.setAngle(this.angle += deltaTheta);
      };

      this.setNeedle = function (x_component, y_component) {
          this.needle_x[0] = this.handBase[0] + (this.clockwiseLayout ? x_component : -x_component);
          this.needle_y[0] = this.handBase[1] + y_component;

          this.needle_x[1] = this.handBase[0] + (this.clockwiseLayout ? +y_component : -y_component) / 3;
          this.needle_y[1] = this.handBase[1] - x_component / 3;

          this.needle_x[2] = this.handBase[0] + (this.clockwiseLayout ? -y_component : +y_component) / 3;
          this.needle_y[2] = this.handBase[1] + x_component / 3;
      };

      /*
       * Set the upper left-hand corner of the dial,
       * offset from the upper left-hand corner of the
       * enclosing applet.
       */
      this.setPositionOffsets = function (offsetArray) {
          this.positionOffsets = offsetArray;

          this.handBase[0] = this.positionOffsets[0] + DialFace.prototype.centroid[0];
          this.handBase[1] = this.positionOffsets[1] + DialFace.prototype.centroid[1];
          this.update(0);
      };

      this.update = function (time) {
          this.updateAngle(this.dialSpeed * time);
      };

      /*
       * Transform the angle theta from applet pixel x-y coordinates
       * to the local dial coordinate system, depending on whether
       * dial layout is clockwise or counterclockwise.
       */
      this.transformAngle = function (theta) {
          if (this.clockwiseLayout) {
              if (theta <= (3 * Math.PI / 2)) {
                  theta = (Math.PI / 2) + theta;
              } else if (theta > (3 * Math.PI / 2)) {
                  theta = theta - (3 * Math.PI / 2);
              }
          }
          if (!this.clockwiseLayout) {
              if (theta <= (3 * Math.PI / 2)) {
                  theta = (3 * Math.PI / 2) - theta;
              } else if (theta > (3 * Math.PI / 2)) {
                  theta = (3 * Math.PI / 2) - theta + (2 * Math.PI);
              }
          }
      };

      /*
       * This is an important method.  When an angle is give (in applet
       * pixel coordinates) this method returns the change in angle between
       * what is requested by the applet and the current setting of the dial.
       * For more information on vector dot products and cross products, consult
       * any college freshman-level calculus based physics text book.
       * The use of these mathematical structures greatly simplifies the necessary
       * coding of the method.
       *
       * A spot of trigonometry is used at the end by testing the signs of the
       * calculated sine and cosine values of the vector products to determine
       * which the quadrant of the resulting angular change.
       */
      this.alignDial = function (theta) {
          // Transform the desired angle to from applet pixel coordinates
          // to local dial coordinates.
          theta = transformAngle(theta);

          /*
           * We use vector algebra to determine the displacement angle between
           * the current setting of the dial and the selected position (theta).
           *
           * 1) Compute the x-y components of unit vector <A> which gives the
           *    direction of the current dial setting.  Vector <A> is a unit
           *    vector so its magnitude is equal to one: |A| = 1.
           *
           * 2) Compute the x-y components of unit vector <B> which gives the
           *    desired direction of the dial setting. Vector <B> is a unit
           *    vector so its magnitude is equal to one: |B| = 1.
           *
           * 3) Compute the magnitude of |C| of vector <C> = <A> X <B>, the
           *    vector cross product of <A> and <B>.  From vector algebra, we
           *    know |C| = |A| * |B| * sin(delta_Angle) = sin(delta_Angle).
           *
           * 4) Compute the vector dot product D of vectors <A> and <B>.  For the
           *    vector dot product D = |A| * |B| * cos(delta_Angle) = cos(delta_Angle).
           *
           */
          var A_x = Math.cos(this.angle);   // Components of dial unit vector.
          var A_y = Math.sin(this.angle);

          var B_x = Math.cos(theta);   // Components of unit vector of selected position.
          var B_y = Math.sin(theta);

          var C_z = A_x * B_y - A_y * B_x;   // Magnitude of Vector Cross Product.
          var D = A_x * B_x + A_y * B_y;   // Vector Dot Product.

          var deltaAngle = 0;

          // Angle in quadrant I.
          if (C_z >= 0 && D >= 0) {
              deltaAngle = Math.asin(C_z);
          }

          // Angle in quadrant II.
          if (C_z >= 0 && D < 0) {
              deltaAngle = Math.acos(D);
          }

          // Angle in quadrant III.
          if (C_z < 0 && D < 0) {
              deltaAngle = (2 * Math.PI) - Math.acos(D);
          }

          // Angle in quadrant IV.
          if (C_z < 0 && D >= 0) {
              deltaAngle = Math.asin(C_z);
          }

          return deltaAngle;
      };

      /*
       * This method really tests whether the needle on the dial
       * has been selected by the mouse via the vector cross 
       * product.
       * 
       * The vector A is the displacement vector from the j-th
       * point of the needle to the location (x,y).
       * 
       * The vector B is the displacement vector from the j-th
       * point of the needle to the (j+1)-th point of the needle.
       * 
       * The 3 points of the needle are traversed in a counter-clockwise
       * sense.
       * 
       * In a right-handed coordinate system, the vector cross-product
       * AxB would be negative (i.e. "into the page") when this test is 
       * made for a point (x,y) against all three edges of the needle.
       * 
       * Since the canvas is a left-handed coordinate system,
       * the cross-product value AxB must be positive (i.e. "out of the page")
       * when this test is made for point (x,y) against all three edges
       * of the needle. 
       * 
       */
      this.isDialSelected = function (x, y) {
          var isSelected = true;
          for (j = 0; j < this.needle_x.length; j++) {

              // Displacement vector from location j to location (x,y).
              var A_x = x - this.needle_x[j];
              var A_y = y - this.needle_y[j];

              // Displacement vector from location j to location j+1.
              var B_x = this.needle_x[(j + 1) % this.needle_x.length] - this.needle_x[j];
              var B_y = this.needle_y[(j + 1) % this.needle_y.length] - this.needle_y[j];

              // Take the vector cross-product of these displacement vectors.
              var crossProd = A_x * B_y - A_y * B_x;

              // If cross-product is negative, (x,y) location lies outside
              // the needle.
              if (crossProd > 0.0) {
                  isSelected = false;
              }
          }
          return isSelected;
      };

      /*
       * This method tests whether the circular part of the dial has
       * been selected by the mouse.
       */
      this.isDialClicked = function (x, y) {
          var r = Math.pow(x - this.handBase[0], 2) + Math.pow(y - this.handBase[1], 2);
          r = Math.sqrt(r);
          if (r <= 45) {
              return true;
          } else {
              return false;
          }
      };

      /*
       * This method tests whether the digit displayed below
       * the dial has been selected by the mouse.
       */
      this.isDigitSelected = function (x, y) {
          var x_0 = this.handBase[0] - 6;
          var y_0 = this.handBase[1] + 50;
          var x_1 = x_0 + digit_images[0].naturalWidth;
          var y_1 = y_0 + digit_images[0].naturalHeight;
          var isSelected = false;
          if ((x_0 <= x && x <= x_1) && (y_0 <= y && y <= y_1)) {
              isSelected = true;
          }
          return isSelected;
      };

      /*
       * Method used to draw the dial face to the screen
       */
      this.draw = function () {

          // dial interface.
          // 1) Clear the dial face with white.
          context.fillStyle = WHITE;
          context.fillRect(this.positionOffsets[0] + DialFace.prototype.centroid[0] - radius - 2, this.positionOffsets[1] + DialFace.prototype.centroid[1] - radius - 2, 2 * (radius + 2) + 1, 2 * (radius + 2) + 28);

          // 2) Draw the background arrow, clockwise or counterclockwise.
          if (this.clockwiseLayout) {
              context.drawImage(arrow_cw, this.positionOffsets[0] + DialFace.prototype.centroid[0] - arrow_cw.naturalWidth / 2, this.positionOffsets[1] + DialFace.prototype.centroid[1] - arrow_cw.naturalHeight / 2);
          } else {
              context.drawImage(arrow_ccw, this.positionOffsets[0] + DialFace.prototype.centroid[0] - arrow_ccw.naturalWidth / 2, this.positionOffsets[1] + DialFace.prototype.centroid[1] - arrow_ccw.naturalHeight / 2);
          }

          // 3) Draw the needle for the dial.

          if (echoOutput) {
  //            console.log("Drawing needle point 0 [" + this.needle_x[0] + "," + this.needle_y[0] + "]");
  //            console.log("Drawing needle point 1 [" + this.needle_x[1] + "," + this.needle_y[1] + "]");
  //            console.log("Drawing needle point 2 [" + this.needle_x[2] + "," + this.needle_y[2] + "]");
  //            console.log("");
          }
          context.beginPath();
          context.moveTo(this.needle_x[0], this.needle_y[0]);
          context.lineTo(this.needle_x[1], this.needle_y[1]);
          context.lineTo(this.needle_x[2], this.needle_y[2]);
          context.lineTo(this.needle_x[0], this.needle_y[0]);
          context.closePath();
          context.strokeStyle = BLACK;
          context.fillStyle = BLACK;
          context.fill();

          // 4) Draw the dial face, clockwise or counterclockwise.
          if (this.clockwiseLayout) {
              context.drawImage(dial_face_cw, this.positionOffsets[0] + DialFace.prototype.centroid[0] - dial_face_cw.naturalWidth / 2, this.positionOffsets[1] + DialFace.prototype.centroid[1] - dial_face_cw.naturalHeight / 2);
          } else {
              context.drawImage(dial_face_ccw, this.positionOffsets[0] + DialFace.prototype.centroid[0] - dial_face_ccw.naturalWidth / 2, this.positionOffsets[1] + DialFace.prototype.centroid[1] - dial_face_ccw.naturalHeight / 2);
          }

          // 5) Draw corresponding digit under the dial.
          var digitImageIndex = this.getDigit();
          context.drawImage(digit_images[digitImageIndex], this.handBase[0] - 6, this.handBase[1] + 50);

          // 6) If the dial or digit is selected, draw a red box around the digit.
          if (this.digitSelected || this.dialSelected) {
              if (this.digitSelected) {
                  console.log("Drawing red box...");
              }
              context.beginPath();
              context.moveTo(this.handBase[0] - 7, this.handBase[1] + 49);
              context.lineTo(this.handBase[0] - 7 + digit_images[digitImageIndex].naturalWidth + 2, this.handBase[1] + 49);
              context.lineTo(this.handBase[0] - 7 + digit_images[digitImageIndex].naturalWidth + 2, this.handBase[1] + 49 + digit_images[digitImageIndex].naturalHeight + 2);
              context.lineTo(this.handBase[0] - 7, this.handBase[1] + 49 + digit_images[digitImageIndex].naturalHeight + 2);
              context.closePath();
              context.strokeStyle = RED;
              context.lineWidth = 1;
              context.stroke();
          }
      };

  }

  function GearBox() {

      //--- PUBLICALLY ACCESSIBLE VARIABLES (exposed with "this"). --//

      // Boolean flags to track if a dial or digit is selected.
      this.dialSelected = false;
      this.digitSelected = false;

      // Integers to track which dial or digit is selected.
      this.indexDialSelected = 0;
      this.indexDigitSelected = 0;

      // Coordinates of the center of the selected dial.
      this.centerDialSelected = [0, 0];
      this.coords_old = [0, 0];

      // The dial face objects, stored as an array.
      this.dials = new Array(
              new DialFace(), new DialFace(), new DialFace(), new DialFace()
              );

      // Initialize position offsets for the individual dials.
      for (i = 0; i < this.dials.length; i++) {

          var dial = this.dials[i];

          var offsetArray = [dialBuffer_x + 100 * i, dialBuffer_y];
          dial.setPositionOffsets(offsetArray);

          // Set whether the dial layout is clockwise or counterclockwise.
          if ((i + 1) % 2 !== 0) {
              dial.clockwiseLayout = false;
          }

          // Set the relative dial speeds.  These are integer multiples of 10.
          // For the third dial, the speed is set to 1/10 Hertz.
          dial.dialSpeed = 2 * Math.PI / 10 * Math.pow(10, i - 2);
      }


      this.update = function (timeStep) {
          if (updateAnimation) {
              for (i = 0; i < this.dials.length; i++) {
                  this.dials[i].update(timeStep);
              }
          }
      };

      // Convenience method used to display the dials.
      this.draw = function () {
          for (i = 0; i < this.dials.length; i++) {
              this.dials[i].draw();
          }
      };

      //== EVENT HANDLING FUNCTIONS ==//

      /*
       * This method is used to test if a particular dial has been
       * selected by a mouse-press.  If a dial is selected, the center
       * coordinates of the dial are stored in centerDialSelected and
       * the index is noted.  This is a precursor method for mouse
       * dragging and is distinct from the following method.
       */
      this.isDialSelected = function (x, y) {
          if (echoOutput) {
              console.log("Entering isDialSelected(x,y)...");
          }
          this.dialSelected = false;
          for (i = 0; i < this.dials.length; i++) {
              if (this.dials[i].isDialSelected(x, y)) {
                  this.dialSelected = true;
                  this.indexDialSelected = i;
                  this.centerDialSelected = this.dials[i].handBase;
                  break;
              }
          }
      };

      /*
       * This method is used to test if a particular dial has been
       * selected by a mouse-clicked.  If a dial is clicked, the center
       * coordinates of the dial are stored in centerDialSelected and
       * the index is noted.  The dials are then adjusted in conformity with                                    
       * the click position and the current position of the other dials.
       */
      this.isDialClicked = function (x, y) {
          if (echoOutput) {
              console.log("Entering isDialClicked(x,y)...");
          }

          if (this.isDigitSelectedByXY(x, y)) {
              return;
          }

          this.dialSelected = false;
          for (i = 0; i < this.dials.length; i++) {
              if (this.dials[i].isDialClicked(x, y)) {
                  this.dialSelected = true;
                  this.indexDialSelected = i;
                  this.indexDigitSelected = i;
                  this.centerDialSelected = this.dials[i].handBase;
                  for (j = 0; j < this.dials.length; j++) {
                      this.dials[j].digitSelected = false;
                  }
                  break;
              }
          }

          if (this.dialSelected) {
              if (echoOutput) {
                  console.log("Setting digit " + this.indexDigitSelected + " as selected.");
              }
              this.dials[this.indexDigitSelected].digitSelected = true;
              if (echoOutput) {
                  console.log("dial[" + this.indexDigitSelected + "].digitSelected=" + this.dials[this.indexDigitSelected].digitSelected);
              }
              return true;
          } else {
              this.dials[this.indexDigitSelected].digitSelected = false;
              return false;
          }
      };


      /*
       * This method is invoked when the mouse is pressed to see if
       * any of the dial digits are selected. If one is found to be
       * selected, the digitSelected flag for that dial is marked true.
       */
      this.isDigitSelectedByXY = function (x, y) {
          this.digitSelected = false;
          for (i = 0; i < this.dials.length; i++) {
              if (this.dials[i].isDigitSelected(x, y)) {
                  this.digitSelected = true;
                  this.dialSelected = true;
                  this.indexDialSelected = i;
                  this.indexDigitSelected = i;
                  for (j = 0; j < this.dials.length; j++) {
                      this.dials[j].digitSelected = false;
                  }
                  break;
              }
          }

          if (this.digitSelected) {
              if (echoOutput) {
                  console.log("Setting digit " + this.indexDigitSelected + " as selected.");
              }
              this.dials[this.indexDigitSelected].digitSelected = true;
              if (echoOutput) {
                  console.log("dial[" + this.indexDigitSelected + "].digitSelected=" + this.dials[this.indexDigitSelected].digitSelected);
              }
              return true;
          } else {
              this.dials[this.indexDigitSelected].digitSelected = false;
              return false;
          }
      };

      /*
       * This method is invoked by the GUI when a key is typed to
       * test whether or not a numerical digit has been typed.
       * If so, the digit typed is converted into a fractional turn of
       * the dial (measured in radians) and this is used to reset
       * the dial position using method setDialFromDigit.
       */
      this.isDigitTyped = function (character) {
          if (echoOutput) {
              console.log("Entering isDigitTypes(character)...");
          }

          // Grab the digit.
          var digitValue = character - 48;
          if (echoOutput) {
              console.log("Digit typed = " + digitValue);
          }

          // If a digit is selected and a digit is typed, update the dials.
          if (0 <= digitValue && digitValue <= 9) {
              // Convert the digit to an equivalent fractional turn on the dial.
              var newAngle = (1.0 * digitValue / 10) * (2 * Math.PI);

              this.setDialFromDigit(newAngle);

              return true;
          } else {
              return false;
          }
      };

      /*
       *  This is an important method for this class!  Here is the gear box itself!
       *  The dials are updated based on the new angle of the selected dial.
       *  We start with the right-hand dials relative to the selected dial
       *  and determine the correction that must be given to newAngle (which
       *  should be proved as an angle measured in radians to the nearest 1/10
       *  of a turn).  After the "right-hand" corrections are made to newAngle,
       *  the selected dial is then set.  Next the left-hand dials are corrected
       *  in light of the new setting on the selected dial.
       */
      this.setDialFromDigit = function (newAngle) {

          if (echoOutput) {
              console.log("Entering setDialFromDigit(newAngle)...");
          }

          if (echoOutput) {
              console.log("  Updating lower-order dials...");
          }
          // Update the lower-order dials in light of this change.
          // Start at the lowest order dial and work up to the dial
          // next to the one selected.
          for (i = this.dials.length - 1; i > this.indexDigitSelected; i--) {
              if (i < this.dials.length - 1) {
                  newAngle += (2 * Math.PI) * (this.dials[i].getDigit() / 10) * Math.pow(10, this.indexDigitSelected - i);
              } else if (i === this.dials.length - 1) {
                  newAngle += this.dials[i].angle * Math.pow(10, this.indexDigitSelected - i);
              }
          }

          if (echoOutput) {
              console.log("  Updating dial of selected digit...");
          }
          // Update the dial of the selected digit.
          this.dials[this.indexDigitSelected].setAngle(newAngle);

          if (echoOutput) {
              console.log("  Updating higher-order dials...");
          }

          // Update the higher-order dials in light of this change.
          // Start with the next-highest order dial from the one seleced
          // and work to the highest order.
          for (i = (this.indexDigitSelected - 1); i >= 0; i--) {
              var angle = (2 * Math.PI) * (this.dials[i].getDigit() / 10);
              for (j = i + 1; j < this.dials.length; j++) {
                  if (j < this.dials.length - 1) {
                      angle += (2 * Math.PI) * (this.dials[j].getDigit() / 10) * Math.pow(10, i - j);
                  } else if (j === this.dials.length - 1) {
                      angle += this.dials[j].angle * Math.pow(10, i - j);
                  }
              }
              this.dials[i].setAngle(angle);
          }
      };

      /*
       * Auxilary method to compute angles (measured in radians) relative to the
       * default x-y pixel coordinate system.
       */
      this.getAngle = function (x, y) {
          var radius = Math.abs(Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2)));
          var angle = 0;
          // Determine the angle using inverse cosine.
          try {
              angle = Math.acos(x / radius);
              // If the angle is less than 0, add 2*pi to give a positive angle.
              if (y < 0) {
                  angle = (2 * Math.PI) - angle;
              }
          } catch (err) {
          }
          return angle;
      };
  }
  
}]);
